var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpFilterDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4238_1840)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.44153 12.0663H5.65327C3.63764 12.0663 2.63011 12.0663 2.00378 11.4281C1.37744 10.79 1.37744 9.76278 1.37744 7.70892C1.37744 5.65506 1.37744 4.62785 2.00378 3.9897C2.63011 3.35156 3.63764 3.35156 5.65327 3.35156H7.79147C9.8071 3.35156 10.8152 3.35156 11.4415 3.9897C11.9234 4.48054 12.0341 5.20189 12.06 6.44388",
    strokeWidth: 1.08,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.24863 3.34284L9.19241 3.16854C8.91466 2.3027 8.77523 1.86977 8.44407 1.62239C8.11235 1.375 7.67268 1.375 6.79277 1.375H6.64434C5.76443 1.375 5.3242 1.375 4.99304 1.62239C4.66169 1.8695 4.52276 2.30173 4.24507 3.16565L4.24414 3.16854L4.18848 3.34284M7.56191 10.0897C7.56191 10.422 7.62736 10.751 7.7545 11.0579C7.88165 11.3649 8.06802 11.6438 8.30296 11.8787C8.5379 12.1137 8.81681 12.3001 9.12377 12.4272C9.43074 12.5543 9.75974 12.6198 10.092 12.6198C10.4242 12.6198 10.7532 12.5543 11.0602 12.4272C11.3672 12.3001 11.6461 12.1137 11.881 11.8787C12.116 11.6438 12.3023 11.3649 12.4295 11.0579C12.5566 10.751 12.6221 10.422 12.6221 10.0897C12.6221 9.41869 12.3555 8.77516 11.881 8.30068C11.4065 7.8262 10.763 7.55964 10.092 7.55964C9.42097 7.55964 8.77744 7.8262 8.30296 8.30068C7.82847 8.77516 7.56191 9.41869 7.56191 10.0897Z",
    strokeWidth: 1.08,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8518 10.8492L10.0928 10.3432V9.07812",
    strokeWidth: 0.963839,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#CCCCCC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4238_1840"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpFilterDark);
export default __webpack_public_path__ + "static/media/exp-filter-dark.d9ad33a185f4be835c1de1deb4a5a0e6.svg";
export { ForwardRef as ReactComponent };